import { config } from "src/stateManagement/redux/configVar";
import { ActivitiesByDatesToAssigned } from "src/tecnica/pages/dashboard/listLocation/components/activityManagerModule";
import { ActivePlanningActivity } from "src/tecnica/pages/dashboard/reports/close_daily/updateTaskModal";
import { Buffer } from "buffer";
 


export const updatePlanningActivityStatus = async (activePlanningActivity: ActivePlanningActivity) => {
    try {

        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivityStatus`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(activePlanningActivity)
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error })
    }
}


export const updatePlanningActivity = async (task: any) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivity`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(task)
        });

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
    }

}

export interface OptimizationActivitiesSelected {
    id: string;
    name: string;
    simulated: boolean;
    optimizationActivityId: string;
    main: boolean;
    isWellWithMultiplesTDSEntries: boolean;
}

export interface IUpdateDiagnosticForActivity {
    originFieldActivityIds: string[];
    projectId: string;
    locationId: string;
    diagnostic: string;
    recommendation: string;
    candidateSate: string;
    bottomHoleCondition: string;
    requiredUserId: string;
    executedAt: Date;
    subBottomHoleCondition: string;
    bottomHoleFillage: number;
    ept: number
    theoricalProduction: number;
    pumpEfficiency: number;
    adjustProduction: number;
    mpt: number;
    dplunger: number;
    newFieldActivityState: string;
    optimizationActivitiesSelected: OptimizationActivitiesSelected[];
    analyzedBy?: string;
    analyzedDate?: Date;
    includeAttachments: boolean;
    attachedFiles: any[];
    runLife: number;
    lastSubSurfaceJobFinishedDate: string;
    daysAfterSteamInjection: number;
    lastLocationEventHistoryChangeDate: string;
    cicleCount: number;
}

export const UpdateDiagnosticForActivity = async (analyst: IUpdateDiagnosticForActivity) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/addDiagnosticActivities`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(analyst)
        });

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
    }
}

export const updateFieldVariablesValues = async (fieldVariables: any) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/updateFieldActivityVariable`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(fieldVariables)
        });

        if (response?.status !== 200 && response?.status !== 201) {
            throw new Error(`Error Cargando los datos: ${response.status}`);
        }

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
        throw new Error(`Error Cargando los datos: ${error}`);
    }
}

export interface UploadFileForWellDto {
    projectId: string;
    id: string;
    data: any[],
    commitChange: boolean;
}

export const addWellInformation = async (wellInformation: UploadFileForWellDto) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/uploadFileForWells`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(wellInformation)
        });

        if (response?.status !== 200 && response?.status !== 201) {
            throw new Error(`Error Cargando los datos: ${response.status}`);
        }

        const json = await response.json();

        return json;
    } catch (error) {
        console.log({ error });
        throw new Error(`Error Cargando los datos: ${error}`);
    }
}

export const assignedActivitiesToUser = async (userId: string, fieldActivityIdsToAssigne: ActivitiesByDatesToAssigned[], fieldActivityIdsToUnassigne: string[]) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/assignFieldActivitiesToUser`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId,
                fieldActivityIdsToAssigne,
                fieldActivityIdsToUnassigne
            })
        });

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
    }
}

export const uploadActivitiesFromMobile = async (sortActivities: any[],vehicleOverview:any) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const batchSize = 100;

        for (let i = 0; i < sortActivities.length; i += batchSize) {
            const batch = sortActivities.slice(i, i + batchSize);
            try {

                const body = {
                    activities: batch,
                    vehicleOverview,
                }

                const url = `${serverUrl}/api/operations/updateFieldActivityVariableAndPictureFromMobile`;

                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                    body: JSON.stringify(body),
                });

                
                const data = await response.json();

                return data

            } catch (error) {

            }
        }

    } catch (error) {
        console.log({ error })
    }
}

export const uploadImages = async (imagesOfActivities: any[]) => {
    try {;

       let token = localStorage.getItem("authToken");

       const serverUrl = config.serverUrl;
      
      

       for (const image of imagesOfActivities) {

           const urltoGetSignedUrl = `${serverUrl}/api/shared/getUrlToUploadFile`;

           const fields = Object.keys(image)
               .filter((key) => !isNaN(Number(key)))
               .map((key) => image[key])
               .filter(
                   (item: any) =>
                       item &&
                       typeof item === "object" &&
                       "name" in item &&
                       "value" in item
               );

           const tipoActividad =
               fields.find((f) => f.name === "Tipo Actividad")?.value ||
               "SinTipo";
           const horaEntrada =
               fields.find((f) => f.name === "Hora Entrada")?.value ||
               "SinHora";
           const cuadrilla =
               fields.find((f) => f.name === "Cuadrilla")?.value ||
               "SinCuadrilla";

           const pozo =
               fields.find((f) => f.name === "Pozo")?.value || "SinPozo";


           const fileName = `${tipoActividad}_${horaEntrada}_${cuadrilla}_${image.counter}.jpg`;
           const fileKey = `${pozo}/${tipoActividad}/${image?.executedAt}/${fileName}`;
           const cleanKey = fileKey
               .normalize("NFD")
               .replace(/[\u0300-\u036f]/g, "");

           const responseSignedUrl = await fetch(urltoGetSignedUrl, {
               method: "GET",
               headers: {
                   "Content-Type": "application/json",
                   authorization: `${token}`,
                   fileName: cleanKey,
                   fileType: "image/jpeg",
               },
           });

            let signedUrl = await responseSignedUrl.json();

             signedUrl = signedUrl?.url || "";

             if (!signedUrl) {
                 return { messages: [], errors: ["Failed to get signed URL"] };
             }

             const response = await fetch(signedUrl, {
                 method: "PUT",
                 headers: {
                     "Content-Type": "image/jpeg",
                 },
                 body: Buffer.from(image.base64, "base64"),
             });

             if (!response.ok) {
                 const errorData = await response.json();
                 return {
                     messages: [],
                     errors: [errorData.message || "Failed to upload image"],
                 };
             }

             const urlToAssociateFileToActivity = `${serverUrl}/api/operations/asociateFieldActivityToOptimizationActivity`;

             const body = {
                 name: fileName,
                 fileKey: fileKey,
                 contentType: "jpg",
                 locationName: pozo || "",
                 locationId: image?.locationId || "",
                 fieldActivityId: image?.fieldId || "",
                 attachedRelatedDate: image?.executedAt || "",
                 description: image?.description || "",
                 lat: image?.latitude || 0,
                 lng: image?.longitude || 0,
                 tags: image?.tags || [],
             };

             await fetch(
                 urlToAssociateFileToActivity,
                 {
                     method: "POST",
                     headers: {
                         "Content-Type": "application/json",
                         authorization: `${token}`,
                     },
                     body: JSON.stringify(body),
                 }
             );
    }
    }catch (error) {
        console.log({ error })
    }
}

export const uploadSingleImage = async (image: any) => {
    let token = localStorage.getItem("authToken");

    const serverUrl = config.serverUrl;

    try {
         const urltoGetSignedUrl = `${serverUrl}/api/shared/getUrlToUploadFile`;

         const fields = Object.keys(image)
             .filter((key) => !isNaN(Number(key)))
             .map((key) => image[key])
             .filter(
                 (item: any) =>
                     item &&
                     typeof item === "object" &&
                     "name" in item &&
                     "value" in item
             );

         const tipoActividad =
             fields.find((f) => f.name === "Tipo Actividad")?.value ||
             "SinTipo";
         const horaEntrada =
             fields.find((f) => f.name === "Hora Entrada")?.value || "SinHora";
         const cuadrilla =
             fields.find((f) => f.name === "Cuadrilla")?.value ||
             "SinCuadrilla";

         const pozo = fields.find((f) => f.name === "Pozo")?.value || "SinPozo";

         const fileName = `${tipoActividad}_${horaEntrada}_${cuadrilla}_${image.counter}.jpg`;
         const fileKey = `${pozo}/${tipoActividad}/${image?.executedAt}/${fileName}`;
         const cleanKey = fileKey
             .normalize("NFD")
             .replace(/[\u0300-\u036f]/g, "");

         const responseSignedUrl = await fetch(urltoGetSignedUrl, {
             method: "GET",
             headers: {
                 "Content-Type": "application/json",
                 authorization: `${token}`,
                 fileName: cleanKey,
                 fileType: "image/jpeg",
             },
         });

         let signedUrl = await responseSignedUrl.json();

         signedUrl = signedUrl?.url || "";

         if (!signedUrl) {
             return { messages: [], errors: ["Failed to get signed URL"] };
         }

         const response = await fetch(signedUrl, {
             method: "PUT",
             headers: {
                 "Content-Type": "image/jpeg",
             },
             body: Buffer.from(image.base64, "base64"),
         });

         if (!response.ok) {
             const errorData = await response.json();
             return {
                 messages: [],
                 errors: [errorData.message || "Failed to upload image"],
             };
         }

         const urlToAssociateFileToActivity = `${serverUrl}/api/operations/asociateFieldActivityToOptimizationActivity`;

         const body = {
             name: fileName,
             fileKey: fileKey,
             contentType: "jpg",
             locationName: pozo || "",
             locationId: image?.locationId || "",
             fieldActivityId: image?.fieldId || "",
             attachedRelatedDate: image?.executedAt || "",
             description: image?.description || "",
             lat: image?.latitude || 0,
             lng: image?.longitude || 0,
             tags: image?.tags || [],
         };

         await fetch(urlToAssociateFileToActivity, {
             method: "POST",
             headers: {
                 "Content-Type": "application/json",
                 authorization: `${token}`,
             },
             body: JSON.stringify(body),
         });
    }catch (error) {
        console.log({ error })
    }          
}